import { AskCancelInput, AskCancelOutput } from '@allocab/allocab-passenger-shared-types';
import { useMutation } from '@tanstack/react-query';
import jwtDecode from 'jwt-decode';

import { mutationKeys } from '../services/datastore/mutationKeys';
import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';
import { AnonymousTokenData } from '../utils/common';

const askAnonymousCancellation = (jwtToken: string) => {
  const tokenData = jwtDecode(jwtToken) as AnonymousTokenData;

  return passengerApi.post<AskCancelInput, AskCancelOutput>(
    '/anonymous/v1/trip/ask-cancellation',
    { key: tokenData.fareEncodedKey },
    { headers: { Authorization: `Bearer ${jwtToken}` } },
  );
};

export const useAskAnonymousCancellation = (jwtToken: string) => {
  const askAnonymousCancellationMutation = useMutation<AskCancelOutput, APIError, void>({
    mutationKey: mutationKeys.askAnonymousCancellation(jwtToken),
    mutationFn: () => askAnonymousCancellation(jwtToken),
  });

  return askAnonymousCancellationMutation;
};
